import React from 'react';
import { IconPaperclip } from '@tabler/icons-react';

const ViewLeaveDetailsModal = ({
    isOpen,
    onClose,
    selectedLeave,
    formatDate,
    getStatusBadge
}) => {
    if (!isOpen || !selectedLeave) return null;

    return (
        <>
            <div className='fixed p-15 w-full max-w-[700px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]'>
                <div className='py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light'>
                    <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                        Leave Request Details
                    </h5>
                    <div className='my-10 md:px-10 px-[7px] max-h-[70vh] overflow-auto cus-scrollbar'>
                        <div className='grid grid-cols-12 gap-20'>
                            <div className='col-span-12 pb-15 border-b border-border'>
                                <div className='flex items-center gap-15'>
                                    {(() => {
                                        const name = selectedLeave.employee_name || selectedLeave.name || '';
                                        const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() || '?';
                                        const COLORS = ['#4f46e5', '#0891b2', '#059669', '#d97706', '#dc2626', '#7c3aed', '#db2777'];
                                        const bg = COLORS[(name.charCodeAt(0) || 0) % COLORS.length];
                                        return (
                                            <div style={{ backgroundColor: bg }} className='w-[60px] h-[60px] rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0'>
                                                {initials}
                                            </div>
                                        );
                                    })()}
                                    <div>
                                        <p className='font-medium text-lg'>{selectedLeave.employee_name || selectedLeave.name}</p>
                                        <p className='text-sm text-text-secondary'>{selectedLeave.employee_id || selectedLeave.employeeId}</p>
                                        <p className='text-sm text-text-secondary'>{selectedLeave.department_name || selectedLeave.department}</p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>Leave Type</p>
                                <p className={`font-medium`}>
                                    {selectedLeave.leave_type_name || selectedLeave.leaveTypeName}
                                </p>
                            </div>
                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>Status</p>
                                {getStatusBadge(selectedLeave.status)}
                            </div>

                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>From Date</p>
                                <p className='font-medium'>{formatDate(selectedLeave.start_date || selectedLeave.fromDate)}</p>
                            </div>
                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>To Date</p>
                                <p className='font-medium'>{formatDate(selectedLeave.end_date || selectedLeave.toDate)}</p>
                            </div>

                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>Total Days</p>
                                <p className='font-medium text-blue text-lg'>{selectedLeave.days || selectedLeave.duration} days</p>
                            </div>
                            <div className='col-span-6'>
                                <p className='text-sm text-text-secondary mb-1'>Applied Date</p>
                                <p className='font-medium'>{formatDate(selectedLeave.created_at || selectedLeave.appliedDate)}</p>
                            </div>

                            <div className='col-span-12'>
                                <p className='text-sm text-text-secondary mb-1'>Reason</p>
                                <p className='font-medium'>{selectedLeave.reason}</p>
                            </div>

                            {selectedLeave.attachments?.length > 0 && (
                                <div className='col-span-12'>
                                    <p className='text-sm text-text-secondary mb-6'>Attachments</p>
                                    <div className='flex flex-col gap-6'>
                                        {selectedLeave.attachments.map(att => (
                                            <a
                                                key={att.id}
                                                href={att.file}
                                                target='_blank'
                                                rel='noreferrer'
                                                className='flex items-center gap-8 bg-bg-light border border-border rounded-md px-10 py-6 hover:border-primary transition-colors'
                                            >
                                                <IconPaperclip size={14} className='text-text-secondary flex-shrink-0' />
                                                <span className='text-xs text-primary truncate'>{att.original_filename || att.file.split('/').pop()}</span>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {selectedLeave.status !== 'pending' && (
                                <>
                                    <div className='col-span-12 pt-15 border-t border-border mt-5'>
                                        <p className='text-sm text-text-secondary mb-1'>Approved/Rejected By</p>
                                        <p className='font-medium'>{selectedLeave.approver || 'Manager'}</p>
                                    </div>
                                    <div className='col-span-6'>
                                        <p className='text-sm text-text-secondary mb-1'>Date</p>
                                        <p className='font-medium'>{formatDate(selectedLeave.approvalDate || selectedLeave.updated_at)}</p>
                                    </div>
                                    <div className='col-span-12'>
                                        <p className='text-sm text-text-secondary mb-1'>Comments</p>
                                        <p className='font-medium'>{selectedLeave.comments || '-'}</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className='md:px-10 px-[7px] flex gap-10 justify-end py-10'>
                        <button onClick={onClose} className='btn btn-primary'>
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <div onClick={onClose} className='fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]'></div>
        </>
    );
};

export default ViewLeaveDetailsModal;
